if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';
			this.currentProduct = null;
			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');
			const spinner = opener.querySelector('.loading-overlay__spinner');
			if (spinner) spinner.classList.remove('hidden');

			const productUrl = opener.getAttribute('data-product-url');
			const brandName = opener.getAttribute('data-brand-name') || '';
			const handle = productUrl.split('/products/')[1]?.split(/[?#\/]/)[0];

			fetch(`/products/${handle}.js`)
				.then(r => r.json())
				.then((product) => {
					this.currentProduct = product;
					this.productUrl = productUrl;
					this.buildPopup(product, productUrl, brandName);
					super.show(opener);
				})
				.catch(err => {
					console.error('Quick add error:', err);
					window.location = productUrl;
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');
					if (spinner) spinner.classList.add('hidden');
				});
		}

		buildPopup(product, productUrl, brandName) {
			const v = product.variants[0];
			const image = product.featured_image || product.images?.[0] || '';
			const hasVariants = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

			let optionsHTML = '';
			if (hasVariants && product.options) {
				product.options.forEach((opt, i) => {
					const name = typeof opt === 'string' ? opt : opt.name;
					const values = typeof opt === 'string'
						? [...new Set(product.variants.map(vr => vr[`option${i + 1}`]).filter(Boolean))]
						: opt.values || [];
					optionsHTML += `
						<div class="qap__option">
							<label>${this.esc(name)}</label>
							<select data-option-index="${i}">
								${values.map(val => `<option value="${this.esc(val)}">${this.esc(val)}</option>`).join('')}
							</select>
						</div>`;
				});
			}

			const addText = window.variantStrings?.addToCart || 'Ajouter au panier';
			const soldText = window.variantStrings?.soldOut || 'Épuisé';
			const moreText = window.theme?.quickviewMore || 'Voir tous les détails';

			this.modalContent.innerHTML = `
				<div class="qap">
					<div class="qap__media">
						<img src="${this.sizedImg(image, 800)}" alt="${this.esc(product.title)}" loading="eager">
					</div>
					<div class="qap__info">
						${brandName ? `<span class="qap__vendor">${this.esc(brandName)}</span>` : ''}
						<h2 class="qap__title">${this.esc(product.title)}</h2>
						<div class="qap__price">
							<span class="qap__price-current">${this.money(v.price)}</span>
							${v.compare_at_price && v.compare_at_price > v.price
								? `<s class="qap__price-compare">${this.money(v.compare_at_price)}</s>` : ''}
						</div>
						${optionsHTML}
						<div class="qap__qty">
							<label>Quantité</label>
							<div class="qap__qty-wrap">
								<button type="button" class="qap__qty-btn" data-action="minus" aria-label="Diminuer la quantité">&#8722;</button>
								<input type="number" class="qap__qty-input" value="1" min="1" aria-label="Quantité">
								<button type="button" class="qap__qty-btn" data-action="plus" aria-label="Augmenter la quantité">+</button>
							</div>
						</div>
						<button type="button" class="qap__atc button button--primary"
							data-variant-id="${v.id}" ${!v.available ? 'disabled' : ''}>
							<span class="qap__atc-text">${v.available ? addText : soldText}</span>
							<span class="qap__atc-spinner" hidden>
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4 31.4" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" dur="0.8s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/></circle></svg>
							</span>
						</button>
						<div class="qap__error" hidden></div>
						<a href="${productUrl}" class="qap__details">${moreText}</a>
					</div>
				</div>`;

			// Wire variant selectors
			this.modalContent.querySelectorAll('.qap__option select').forEach(sel => {
				sel.addEventListener('change', () => this.onVariantChange());
			});

			// Wire ATC button
			this.modalContent.querySelector('.qap__atc').addEventListener('click', (e) => {
				const btn = e.currentTarget;
				const vid = btn.dataset.variantId;
				const qty = parseInt(this.modalContent.querySelector('.qap__qty-input').value) || 1;
				this.addToCart(vid, qty);
			});

			// Wire qty +/- buttons
			this.modalContent.querySelectorAll('.qap__qty-btn').forEach(btn => {
				btn.addEventListener('click', () => {
					const input = this.modalContent.querySelector('.qap__qty-input');
					let val = parseInt(input.value) || 1;
					if (btn.dataset.action === 'minus' && val > 1) val--;
					if (btn.dataset.action === 'plus') val++;
					input.value = val;
				});
			});
		}

		onVariantChange() {
			const selects = this.modalContent.querySelectorAll('.qap__option select');
			const chosen = [...selects].map(s => s.value);

			const variant = this.currentProduct.variants.find(v =>
				chosen.every((opt, i) => v[`option${i + 1}`] === opt)
			);

			const btn = this.modalContent.querySelector('.qap__atc');
			const priceEl = this.modalContent.querySelector('.qap__price-current');
			const imgEl = this.modalContent.querySelector('.qap__media img');
			const priceWrap = this.modalContent.querySelector('.qap__price');

			const addText = window.variantStrings?.addToCart || 'Ajouter au panier';
			const soldText = window.variantStrings?.soldOut || 'Épuisé';
			const naText = window.variantStrings?.unavailable || 'Non disponible';

			// Remove old compare price
			const oldCompare = priceWrap.querySelector('.qap__price-compare');
			if (oldCompare) oldCompare.remove();

			if (variant) {
				btn.dataset.variantId = variant.id;
				btn.disabled = !variant.available;
				btn.querySelector('.qap__atc-text').textContent = variant.available ? addText : soldText;

				priceEl.textContent = this.money(variant.price);

				if (variant.compare_at_price && variant.compare_at_price > variant.price) {
					const s = document.createElement('s');
					s.className = 'qap__price-compare';
					s.textContent = this.money(variant.compare_at_price);
					priceEl.after(s);
				}

				if (variant.featured_image?.src && imgEl) {
					imgEl.src = this.sizedImg(variant.featured_image.src, 800);
					imgEl.alt = variant.featured_image.alt || this.currentProduct.title;
				}
			} else {
				btn.disabled = true;
				btn.querySelector('.qap__atc-text').textContent = naText;
			}
		}

		addToCart(variantId, quantity) {
			const btn = this.modalContent.querySelector('.qap__atc');
			const errEl = this.modalContent.querySelector('.qap__error');
			const textEl = btn.querySelector('.qap__atc-text');
			const spinEl = btn.querySelector('.qap__atc-spinner');

			btn.disabled = true;
			textEl.hidden = true;
			spinEl.hidden = false;
			errEl.hidden = true;

			const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

			const body = { id: parseInt(variantId), quantity: quantity };
			if (cart) {
				body.sections = cart.getSectionsToRender().map(s => s.id);
				body.sections_url = window.location.pathname;
			}

			fetch(window.routes.cart_add_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify(body)
			})
				.then(r => r.json())
				.then(response => {
					if (response.status) {
						errEl.textContent = response.description || 'Une erreur est survenue.';
						errEl.hidden = false;
						btn.disabled = false;
						textEl.hidden = false;
						spinEl.hidden = true;
						return;
					}

					// Success
					spinEl.hidden = true;
					textEl.hidden = false;
					textEl.textContent = '✓ Ajouté!';
					btn.classList.add('qap__atc--success');

					if (cart) {
						document.body.addEventListener('modalClosed', () => {
							setTimeout(() => cart.renderContents(response));
						}, { once: true });
					}

					setTimeout(() => this.hide(true), 900);
				})
				.catch(() => {
					errEl.textContent = 'Erreur de connexion. Réessayez.';
					errEl.hidden = false;
					btn.disabled = false;
					textEl.hidden = false;
					spinEl.hidden = true;
				});
		}

		/* ---- Helpers ---- */

		money(cents) {
			const amt = (typeof cents === 'number' ? cents / 100 : parseFloat(cents || 0) / 100).toFixed(2);
			const fmt = window.theme?.moneyFormat || '${{amount}}';
			return fmt
				.replace('{{amount}}', amt)
				.replace('{{amount_no_decimals}}', Math.round(parseFloat(amt)).toString())
				.replace('{{amount_with_comma_separator}}', amt.replace('.', ','))
				.replace('{{amount_no_decimals_with_comma_separator}}', Math.round(parseFloat(amt)).toString());
		}

		sizedImg(src, width) {
			if (!src) return '';
			try {
				const url = new URL(src.startsWith('//') ? 'https:' + src : src);
				url.searchParams.set('width', width);
				return url.toString();
			} catch (e) { return src; }
		}

		esc(str) {
			if (!str) return '';
			const d = document.createElement('div');
			d.textContent = str;
			return d.innerHTML;
		}
	});
}
